// extracted by mini-css-extract-plugin
module.exports = {"scrollAble":"tableWrapper_scrollAble__3gCcK"};